import { useEffect, useMemo, useRef, useState } from 'react';
import { BatchService } from '../../../../services/BatchService';
import { ChangeAlertCallbackType } from '../../../Root';
import { statusBatchConfig, batchType } from '../../../../util/DataObject';
import moment from 'moment';
moment.locale('es');

export const useNotificationsTable = (changeAlert: ChangeAlertCallbackType) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState({batch_uuid: ''});
    const [batchProcess, setBatchProcess] = useState(null);
    const [disabledSearch, setDisabledSearch] = useState(true);
    const batchService = useRef<BatchService>();

    const saveData = async (result) => {
        setLoading(true);       
        setData(result.content || []);
        setLoading(false);
    };

    const onHandleChange = (key, e) => {
        let s = search
        s[key] = e.target.value.trim()
        setSearch(JSON.parse(JSON.stringify(s)));
        setDisabledSearch(JSON.parse(JSON.stringify(!(s.batch_uuid))));
    }

    const onHandleSearch = async () => {
        setLoading(true);
        let request = {
            data: search
        }
        const response = await batchService.current.batchNotificationGet(request);
        if (response.data.response === 'OK') {
            setBatchProcess(response.data?.result || null)
        } else {
            changeAlert(true, 'error', response.data.message);
        }
        setLoading(false);
    }

    const closeBatchDialog = () => {
        setBatchProcess(null)
        setSearch({batch_uuid: ''})
    }

    const onHandleListStatus = async (event: any) => {
        setLoading(true);
        let request = {
            data: {}
        }
        if(event?.target?.value){
            request["data"]["status"] = event.target.value
        }
        const response = await batchService.current.batchNotificationList(request);
        if (response.data.response === 'OK') {
            saveData(response.data?.widget[0].data || []);
        } else {
            changeAlert(true, 'error', response.data.message);
        }
        setLoading(false);
    }

    const onCreateConfig = async (data) => {
        setLoading(true);
        const response = await batchService.current.batchNotificationSave({data: data});
        if (response.data.response === 'OK') {
            onHandleListStatus(null)
        } else {
            changeAlert(true, 'error', response.data.message);
        }
        setLoading(false);
    }

    useEffect(() => {
        batchService.current = new BatchService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => row.batch_uuid, name: 'Batch UUID', wrap: true, width: '22%', sortable: false },
            { selector: (row) => row.type === 'push' ? (row.body.title +": "+ row.body.content) : (row.body.summary || row.body.content), name: 'Descripción', wrap: true, width: '25%', sortable: false },
            { selector: (row) => statusBatchConfig.map((item) => row.status === item.value ? item.label : null), name: 'Estatus', wrap: true, width: '12%', sortable: false },
            { selector: (row) => batchType.filter((item) => row.type === item.value)[0].label, name: 'Tipo', wrap: true, width: '10%', sortable: false },
            { selector: (row) => row.body.template_id, name: 'Template ID', wrap: true, width: '22%', sortable: false },
            { selector: (row) => row.configuration.batch.limit, name: 'Límite', wrap: true, width: '8%', sortable: false },
        ]
        
        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    return { columns: calculateColumns, data, loading, search, disabledSearch, batchProcess, saveData, onHandleListStatus, onCreateConfig, onHandleChange, onHandleSearch, closeBatchDialog }
};